import { OrigemImportacaoXmlNFeEntradaEnum } from '../../../../../shared/enums/suprimentos/origem-importacao-xml-nfe-entrada.enum';

/** Informa de qual fluxo o assistente compartilhado foi aberto. */
export class ImportarXmlNotaFiscalEntradaDialogData {
  origem = OrigemImportacaoXmlNFeEntradaEnum.CentralNotas;
}
